export const getExtent = values => {
  if(values){

    let min = Math.min(...values)
    let max = Math.max(...values)
    return [min, max]
  }
  return [0,0]
}
